export const partners = [
  {
    id: 1,
    name: "Microsoft",
    sector: "Bulut & Üretkenlik Çözümleri",
    founded: "1975",
    shortDesc: "Bulut ve üretkenlik çözümlerinde dünya lideri",
    fullDesc: "C2TEK, Microsoft çözüm ortağı olarak Microsoft 365, Azure bulut ve modern iş yeri çözümlerini kurumlara uçtan uca sunmaktadır. Lisanslama, geçiş ve yönetim süreçleri tek elden yürütülür.",
    longDesc: "Microsoft, bulut altyapısı, üretkenlik uygulamaları ve iş çözümleri alanında dünyanın önde gelen teknoloji şirketidir. C2TEK, Microsoft iş ortaklığı kapsamında müşterilerine Microsoft 365, Azure ve güvenlik çözümlerini lisanslama, mimari tasarım ve uçtan uca uygulama hizmetiyle birlikte sağlar.\n\nE-posta ve dosya altyapısının buluta taşınmasından kimlik yönetimi ve uç nokta güvenliğine kadar tüm Microsoft ekosistemini tek bir çözüm ortağından yöneterek kurumların dijital dönüşüm sürecini hızlandırıyoruz.",
    since: "2018",
    projects: 120,
    website: "https://microsoft.com",
    heroImage: "https://images.unsplash.com/photo-1607799279861-4dd421887fb3?auto=format&fit=crop&w=1200&q=80",
    tags: ["Microsoft 365", "Azure Bulut", "Exchange Online", "Entra ID", "Intune"],
    stats: [
      { label: "Tamamlanan Proje", value: "120+" },
      { label: "İş Ortaklığı", value: "7 Yıl" },
      { label: "Lisanslı Kullanıcı", value: "10K+" }
    ],
    certifications: ["Microsoft Solutions Partner", "Modern Work", "Azure Infrastructure", "Security", "CSP Yetkili Satıcı"],
    keyServices: [
      { title: "Microsoft 365 Geçişi", desc: "Exchange, SharePoint ve OneDrive'a sorunsuz e-posta ve dosya göçü" },
      { title: "Azure Bulut Çözümleri", desc: "Sanal makine, yedekleme ve hibrit bulut mimarisi kurulumu" },
      { title: "Kimlik & Güvenlik", desc: "Entra ID, MFA ve koşullu erişim ile güvenli kimlik yönetimi" },
      { title: "Lisans Yönetimi", desc: "CSP modeliyle optimize edilmiş lisanslama ve abonelik yönetimi" }
    ],
    achievements: [
      { year: "2018", text: "Microsoft iş ortaklığı kuruldu, ilk M365 geçiş projeleri tamamlandı" },
      { year: "2020", text: "Azure tabanlı yedekleme ve hibrit bulut çözümleri portföye eklendi" },
      { year: "2022", text: "Toplam lisanslı kullanıcı sayısı 10.000'i aştı" },
      { year: "2024", text: "Modern Work ve Security uzmanlık alanlarında yetkinlik kazanıldı" }
    ]
  },
  {
    id: 2,
    name: "Cisco",
    sector: "Ağ & Altyapı Sistemleri",
    founded: "1984",
    shortDesc: "Kurumsal ağ teknolojilerinde global lider",
    fullDesc: "Cisco iş ortaklığı kapsamında C2TEK, kurumsal ölçekte yönlendirme, anahtarlama ve kablosuz ağ çözümlerini tasarlar, kurar ve yönetir. Kesintisiz ve güvenli ağ altyapısı garanti altına alınır.",
    longDesc: "Cisco, kurumsal ağ donanımı ve yazılımında dünyanın en büyük tedarikçisidir. C2TEK, Cisco çözümleriyle çekirdek anahtarlama, yönlendirme, kablosuz ağ ve ağ güvenliği projelerini uçtan uca hayata geçirir.\n\nYüksek erişilebilirlikli ağ tasarımı, segmentasyon ve merkezi yönetim ile kurumların büyüyen veri trafiğini güvenli ve performanslı bir şekilde taşımasını sağlıyoruz.",
    since: "2015",
    projects: 95,
    website: "https://cisco.com",
    heroImage: "https://images.unsplash.com/photo-1558346490-a72e53ae2d4f?auto=format&fit=crop&w=1200&q=80",
    tags: ["Catalyst Switch", "Kurumsal Yönlendirme", "Kablosuz Ağ", "Meraki", "Ağ Güvenliği"],
    stats: [
      { label: "Tamamlanan Proje", value: "95+" },
      { label: "İş Ortaklığı", value: "10 Yıl" },
      { label: "Kurulan Cihaz", value: "5K+" }
    ],
    certifications: ["Cisco Select Partner", "CCNA Sertifikalı Ekip", "CCNP", "Meraki Yetkili", "Enterprise Networking"],
    keyServices: [
      { title: "Çekirdek Ağ Tasarımı", desc: "Yüksek erişilebilirlikli omurga anahtarlama ve yönlendirme mimarisi" },
      { title: "Kablosuz Ağ", desc: "Kurumsal kapsama alanı için yoğunluk odaklı Wi-Fi tasarımı" },
      { title: "Meraki Bulut Yönetimi", desc: "Bulut tabanlı merkezi ağ izleme ve yönetim çözümleri" },
      { title: "Ağ Segmentasyonu", desc: "VLAN ve güvenlik politikalarıyla bölümlenmiş güvenli ağ" }
    ],
    achievements: [
      { year: "2015", text: "Cisco iş ortaklığı ile ilk kurumsal ağ projeleri tamamlandı" },
      { year: "2018", text: "Meraki bulut yönetimli ağ çözümleri portföye eklendi" },
      { year: "2021", text: "Çok lokasyonlu kurumlar için merkezi ağ yönetimi standardı kuruldu" },
      { year: "2024", text: "Toplam kurulan ağ cihazı sayısı 5.000'i geçti" }
    ]
  },
  {
    id: 3,
    name: "Fortinet",
    sector: "Siber Güvenlik Çözümleri",
    founded: "2000",
    shortDesc: "Entegre siber güvenlik platformunda lider",
    fullDesc: "Fortinet iş ortaklığı kapsamında C2TEK, yeni nesil güvenlik duvarından uç nokta korumasına kadar entegre bir güvenlik mimarisi sunar. Kurumların verileri çok katmanlı koruma altına alınır.",
    longDesc: "Fortinet, FortiGate güvenlik duvarları ve Security Fabric platformuyla dünya çapında tanınan bir siber güvenlik şirketidir. C2TEK, Fortinet çözümleriyle ağ güvenliği, uç nokta koruması ve merkezi tehdit yönetimini birlikte konumlandırır.\n\nGüvenlik duvarı, web filtreleme, VPN ve SD-WAN çözümlerini tek bir entegre platformda yöneterek kurumların siber tehditlere karşı dirençli hale gelmesini sağlıyoruz.",
    since: "2019",
    projects: 78,
    website: "https://fortinet.com",
    heroImage: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=1200&q=80",
    tags: ["FortiGate Firewall", "SD-WAN", "Uç Nokta Koruması", "VPN", "Security Fabric"],
    stats: [
      { label: "Tamamlanan Proje", value: "78+" },
      { label: "İş Ortaklığı", value: "6 Yıl" },
      { label: "Korunan Uç Nokta", value: "20K+" }
    ],
    certifications: ["Fortinet Advanced Partner", "NSE Sertifikalı Ekip", "FortiGate Uzmanı", "SD-WAN", "Security Operations"],
    keyServices: [
      { title: "Yeni Nesil Güvenlik Duvarı", desc: "FortiGate ile uygulama farkındalıklı derin paket denetimi" },
      { title: "SD-WAN", desc: "Şubeler arası güvenli ve performanslı bağlantı çözümleri" },
      { title: "Uç Nokta Koruması", desc: "FortiClient ile merkezi yönetilen cihaz güvenliği" },
      { title: "Güvenlik İzleme", desc: "Merkezi log yönetimi ve tehdit korelasyonu" }
    ],
    achievements: [
      { year: "2019", text: "Fortinet iş ortaklığı kuruldu, ilk güvenlik duvarı projeleri devreye alındı" },
      { year: "2021", text: "SD-WAN çözümleriyle çok şubeli kurumlara güvenli bağlantı sağlandı" },
      { year: "2023", text: "Security Fabric ile entegre güvenlik mimarisi standart hale getirildi" },
      { year: "2024", text: "Korunan uç nokta sayısı 20.000'i aştı" }
    ]
  },
  {
    id: 4,
    name: "Hewlett Packard Enterprise",
    sector: "Sunucu & Depolama Sistemleri",
    founded: "2015",
    shortDesc: "Kurumsal sunucu ve depolamada güçlü ortak",
    fullDesc: "HPE iş ortaklığı kapsamında C2TEK, kurumsal sunucu, depolama ve veri merkezi çözümlerini sağlar. Yüksek performanslı ve yedekli donanım altyapısı ile kritik iş yükleri güvenle çalıştırılır.",
    longDesc: "Hewlett Packard Enterprise, kurumsal sunucu, depolama ve veri merkezi altyapısı alanında dünyanın önde gelen üreticilerinden biridir. C2TEK, HPE ProLiant sunucuları ve depolama sistemleriyle kurumların veri merkezi altyapısını tasarlar ve kurar.\n\nSanallaştırma, yedekleme ve felaket kurtarma senaryolarına uygun ölçeklenebilir donanım çözümleriyle kritik uygulamaların kesintisiz çalışmasını sağlıyoruz.",
    since: "2014",
    projects: 64,
    website: "https://hpe.com",
    heroImage: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=1200&q=80",
    tags: ["ProLiant Sunucu", "Depolama (SAN)", "Veri Merkezi", "Sanallaştırma", "Yedekleme"],
    stats: [
      { label: "Tamamlanan Proje", value: "64+" },
      { label: "İş Ortaklığı", value: "11 Yıl" },
      { label: "Kurulan Sunucu", value: "800+" }
    ],
    certifications: ["HPE Business Partner", "ProLiant Uzmanı", "Storage", "Aruba Networking", "Hybrid IT"],
    keyServices: [
      { title: "Sunucu Çözümleri", desc: "HPE ProLiant ile yüksek performanslı ve yedekli sunucu altyapısı" },
      { title: "Depolama Sistemleri", desc: "SAN/NAS tabanlı ölçeklenebilir ve hızlı veri depolama" },
      { title: "Veri Merkezi Tasarımı", desc: "Güç, soğutma ve yedeklilik odaklı veri merkezi altyapısı" },
      { title: "Yedekleme & DR", desc: "Felaket kurtarma senaryolarına uygun donanım çözümleri" }
    ],
    achievements: [
      { year: "2014", text: "HPE iş ortaklığı ile ilk sunucu ve depolama projeleri tamamlandı" },
      { year: "2018", text: "Kurumsal veri merkezi yenileme projeleri yaygınlaştı" },
      { year: "2021", text: "Hibrit altyapı çözümleriyle bulut entegrasyonları gerçekleştirildi" },
      { year: "2024", text: "Toplam kurulan sunucu sayısı 800'ü aştı" }
    ]
  },
  {
    id: 5,
    name: "Dell Technologies",
    sector: "İstemci & Veri Merkezi Çözümleri",
    founded: "1984",
    shortDesc: "İstemci ve veri merkezi donanımında lider",
    fullDesc: "Dell Technologies iş ortaklığı kapsamında C2TEK, dizüstü ve masaüstü istemcilerden veri merkezi sunucularına kadar geniş bir donanım yelpazesi sunar. Kurumlara uçtan uca donanım tedariği ve yönetimi sağlanır.",
    longDesc: "Dell Technologies, istemci cihazları, sunucu ve depolama çözümleriyle dünyanın en büyük teknoloji üreticilerinden biridir. C2TEK, Dell ürünleriyle kurumların son kullanıcı cihazlarından veri merkezi donanımına kadar tüm donanım ihtiyacını karşılar.\n\nKurumsal dizüstü ve masaüstü filolarının tedariği, kurulumu ve yaşam döngüsü yönetimini üstlenerek BT operasyonlarını sadeleştiriyoruz.",
    since: "2016",
    projects: 86,
    website: "https://dell.com",
    heroImage: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80",
    tags: ["Latitude & OptiPlex", "PowerEdge Sunucu", "İş İstasyonu", "Donanım Tedariği", "Cihaz Yönetimi"],
    stats: [
      { label: "Tamamlanan Proje", value: "86+" },
      { label: "İş Ortaklığı", value: "9 Yıl" },
      { label: "Teslim Cihaz", value: "15K+" }
    ],
    certifications: ["Dell Authorized Partner", "Client Solutions", "Server & Storage", "ProSupport", "Workstation Uzmanı"],
    keyServices: [
      { title: "Kurumsal İstemciler", desc: "Latitude, OptiPlex ve Precision ile son kullanıcı cihaz çözümleri" },
      { title: "PowerEdge Sunucu", desc: "Veri merkezi ve şube için ölçeklenebilir sunucu donanımı" },
      { title: "Donanım Tedariği", desc: "Toplu cihaz tedariği, kurulum ve dağıtım hizmeti" },
      { title: "Yaşam Döngüsü Yönetimi", desc: "Garanti, ProSupport ve cihaz yenileme süreçleri" }
    ],
    achievements: [
      { year: "2016", text: "Dell iş ortaklığı ile kurumsal cihaz tedariği başladı" },
      { year: "2019", text: "PowerEdge sunucularıyla veri merkezi projeleri portföye eklendi" },
      { year: "2022", text: "Büyük ölçekli cihaz yenileme ve filo yönetimi projeleri tamamlandı" },
      { year: "2024", text: "Toplam teslim edilen cihaz sayısı 15.000'i aştı" }
    ]
  },
  {
    id: 6,
    name: "VMware",
    sector: "Sanallaştırma & Bulut Altyapısı",
    founded: "1998",
    shortDesc: "Sanallaştırma teknolojilerinde dünya lideri",
    fullDesc: "VMware iş ortaklığı kapsamında C2TEK, sunucu sanallaştırma ve özel bulut altyapısı çözümlerini sağlar. Donanım kaynaklarının verimli kullanımı ve yüksek erişilebilirlik garanti altına alınır.",
    longDesc: "VMware, sunucu sanallaştırma ve bulut altyapısı yazılımlarında dünya lideridir. C2TEK, VMware vSphere ve sanallaştırma çözümleriyle kurumların donanım yatırımlarını optimize eder ve yüksek erişilebilirlikli altyapılar kurar.\n\nSanal makine konsolidasyonu, yük dengeleme ve felaket kurtarma çözümleriyle BT altyapısının hem esnek hem de maliyet etkin olmasını sağlıyoruz.",
    since: "2017",
    projects: 52,
    website: "https://vmware.com",
    heroImage: "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?auto=format&fit=crop&w=1200&q=80",
    tags: ["vSphere", "Sanallaştırma", "Özel Bulut", "Yüksek Erişilebilirlik", "vSAN"],
    stats: [
      { label: "Tamamlanan Proje", value: "52+" },
      { label: "İş Ortaklığı", value: "8 Yıl" },
      { label: "Sanal Sunucu", value: "3K+" }
    ],
    certifications: ["VMware Partner", "vSphere Uzmanı", "VCP Sertifikalı Ekip", "vSAN", "Cloud Foundation"],
    keyServices: [
      { title: "Sunucu Sanallaştırma", desc: "vSphere ile donanım kaynaklarının verimli konsolidasyonu" },
      { title: "Yüksek Erişilebilirlik", desc: "vMotion ve HA ile kesintisiz iş yükü çalışması" },
      { title: "Özel Bulut", desc: "Kurum içi ölçeklenebilir özel bulut altyapısı" },
      { title: "Yazılım Tanımlı Depolama", desc: "vSAN ile esnek ve performanslı depolama çözümleri" }
    ],
    achievements: [
      { year: "2017", text: "VMware iş ortaklığı ile ilk sanallaştırma projeleri tamamlandı" },
      { year: "2020", text: "Yüksek erişilebilirlikli kümeler kurumsal standart haline geldi" },
      { year: "2022", text: "vSAN tabanlı yazılım tanımlı depolama çözümleri devreye alındı" },
      { year: "2024", text: "Yönetilen sanal sunucu sayısı 3.000'i aştı" }
    ]
  }
];
